import { render, staticRenderFns } from "./form-header.component.vue?vue&type=template&id=6ffa6332&scoped=true&"
import script from "./form-header.component.vue?vue&type=script&lang=ts&"
export * from "./form-header.component.vue?vue&type=script&lang=ts&"
import style0 from "./form-header.component.vue?vue&type=style&index=0&id=6ffa6332&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffa6332",
  null
  
)

export default component.exports